'use client';

import {createContext, ReactNode, useContext} from 'react';

export type EnvironmentValues = {
    KUBERNETES_NAMESPACE?: string;
    FRONTEND_SELFCARE_URL?: string;
    FRONTEND_SOP_WEB_URL?: string;
    SARA_CLIENT_ID?: string;
    SARA_OAUTH_REDIRECT_URL?: string;
    SARA_AUTHORIZATION_ENDPOINT?: string;
};

export const EnvironmentContext = createContext<EnvironmentValues>({});

type EnvironmentProviderProps = {
    children: ReactNode;
    value: EnvironmentValues;
};

export const EnvironmentProvider = ({children, value}: EnvironmentProviderProps) => {
    return <EnvironmentContext.Provider value={value}>{children}</EnvironmentContext.Provider>;
};

export const useEnvironment = () => useContext(EnvironmentContext);
